import { useQuery } from '@tanstack/react-query'
import { fetchApi } from '@/common/lib/fetchApi'

export type PayPeriodState = 'drafting' | 'active' | 'closed'

export interface DashboardPayPeriod {
  start_date: string
  end_date: string
  state: PayPeriodState | null
}

export interface DashboardTimesheetSummary {
  id: number
  pay_period: DashboardPayPeriod
  status: 'draft' | 'submitted' | 'approved' | 'rejected'
  rejection_reason: string | null
  total_hours: number
  total_standard_hours: number
  total_overtime_hours: number
}

export interface DashboardHoliday {
  name: string
  date: string
}

export interface DashboardTimeOff {
  type: string
  start_date: string
  end_date: string
}

export interface DashboardSummary {
  previous_period: DashboardPayPeriod
  current_period: DashboardPayPeriod
  next_period: DashboardPayPeriod
  timesheets: DashboardTimesheetSummary[]
  holidays: DashboardHoliday[]
  time_off: DashboardTimeOff[]
}

export function useDashboardSummary() {
  return useQuery({
    queryKey: ['dashboard', 'summary'],
    queryFn: () => fetchApi<DashboardSummary>('/api/dashboard/summary'),
  })
}
